import { render, staticRenderFns } from "./WeekSlotsGridConfigure.vue?vue&type=template&id=2f4ab3d4&scoped=true&"
import script from "./WeekSlotsGridConfigure.vue?vue&type=script&lang=js&"
export * from "./WeekSlotsGridConfigure.vue?vue&type=script&lang=js&"
import style0 from "./WeekSlotsGridConfigure.vue?vue&type=style&index=0&id=2f4ab3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ab3d4",
  null
  
)

export default component.exports